<div class="row search-page">
    <div class="col-12">
        <app-search-bar></app-search-bar>
        <app-search-results></app-search-results>
    </div>
</div>